class InvestmentRents {
    latestRentDispersionDate;
    latestAmount;
    latestAmountWithoutTaxes;
    totalHistoricalAmount;
    totalHistoricalAmountWithoutTaxes;
    constructor(data) {
        this.latestRentDispersionDate = data?.latestRentDispersionDate
            ? new Date(data.latestRentDispersionDate)
            : undefined;
        this.latestAmount = data.latestAmount;
        this.latestAmountWithoutTaxes = data.latestAmountWithoutTaxes;
        this.totalHistoricalAmount = data.totalHistoricalAmount;
        this.totalHistoricalAmountWithoutTaxes = data.totalHistoricalAmountWithoutTaxes;
    }
}
export default InvestmentRents;
